import { Button, Paper, Typography } from "@mui/material";
import React, { useCallback, useEffect, useState ,useRef} from "react";
import { Link } from "react-router-dom";
// import { homehandle, upcommingEventsHandle,handleResults,handleJewelry,handleWatches,handlebags,handleAuctionsRoom} from "./RouteFunction";
import { linksData} from "../Model/Navbar";
import { useLocation } from 'react-router-dom';
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
// import HomeIcon from "@mui/icons-material/Home";
import { homehandle } from "./RouteFunction";
import HomeIcon from '@mui/icons-material/Home';
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import {GetURL} from "../config";
// import DirectionsIcon from "@mui/icons-material/Directions";
import { auctionsLive } from "../view/Model/Auction";
// import { useLocation } from "react-router-dom";
const newLink = {
  to: "/auctions/room",
  title: "Live",
  name: "LIVE AUCTION",
  handle: "handleClickLive",
  icon: 'fa fa-television',
  class: "",
};

export default function Menu() {
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState(false);
  const [menuName, setMenuName] = useState("");
  const location = useLocation();
  const [title, setTitle] = useState(document.title);
  const [statusLive, setStatusLive] = useState(false);
  const [lotNumber, setLotNumber] = useState(document.title);

  const hasRun = useRef(false); // holds whether function ran or not

  

  const LiveAuction =  useCallback(() => {
    try {
      async function getAuctionOne() {
        const  results = await auctionsLive();
    
        if (results.success === false) {
          setStatusLive(results.auction_details[0].isLive);
         
        } else {
          
          // alert(results.auction_details.isLive)
          setStatusLive(results.success)
      //  setLotNumber(results.lot.details[0].lot_number)
        
        }
    
      } 
      getAuctionOne().catch(console.error);
    } catch (error) {}
  },[auctionsLive])

                

  useEffect(()=>{

    localStorage.setItem("backUrl",location.pathname)
  if(location.pathname === `/auctions/room` || location.pathname === `/declarator/room`){
    if (!hasRun.current) {
      linksData.splice(1, 0, newLink);
      hasRun.current = true; // set it so it won't run again
    }

  }else{
    if (!hasRun.current) {
       LiveAuction()
      hasRun.current = true; // set it so it won't run again
    }else{

    }
  
  }

 
  if(statusLive === true){
    linksData.splice(1, 0, newLink);
  }else{

  }
 
  },[linksData,statusLive])

  //   const params = new URLSearchParams(search);
  //   const data = params.get('data');
  //   useEffect(() => {
  //     document.title = data;
  // }, [data]);

  function handleSearch(e) {
    e.preventDefault();

    // let searching = search.replace([a-zA-Z0-9\s]+$)
    if (search === "") {
    } else {
      window.location.href = `/search/${search}`;
    }
  }
  // const CallFunction = (event, handle,name) => {
  //   if ("homehandle" === handle) {
  //     return homehandle;
  //   } else if ("upcommingEventsHandle" === handle) {
  //     return upcommingEventsHandle(name);
  //   } else if ("handleResults" === handle) {
  //     return handleResults(name);
  //   } else if ("handleJewelry" === handle) {
  //     return handleJewelry(name);
  //   } else if ("handleWatches" === handle) {
  //     return handleWatches(name);
  //   } else if ("handlebags" === handle) {
  //     return handlebags(name);
  //   } else if ("handleAuctionsRoom" === handle) {
  //     return handleAuctionsRoom();
  //   } else {
  //   }
  // };

  const OnclickStatus = (name) => {
    if (name === "PRIVATE SALE") {
      setMenuName(name);
      setStatus(!status);
    } else if (name === "GALLERIES") {
      setMenuName(name);
      setStatus(!status);
    } else {
    }
  };

  const [leftside, setleftside] = useState(false);
  const ShowLefSide = () => {
    // console.log('ok',leftside)
    setleftside(!leftside);
  };

  const [token, setToken] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem("token");
    const initialValue = saved;
    return initialValue || "";
  });

  // const onCLickLogout = () => {
  //   localStorage.removeItem("@storage_Key");
  //   localStorage.removeItem("token");
  //   window.location.href = "/login";
  // };

  useEffect(() => {
   
    setTitle(document.title);
  }, [document.title,]);

  const handleGotPage = async(value,url) => {
    if (value === "PRIVATE SALE") {
      setMenuName(value);
      setStatus(!status);
    } else if (value === "GALLERIES") {
      setMenuName(value);
      setStatus(!status);  
    } else {    
    }

    if(value === "AUCTIONS"){
    const dataSend = {
      title: 'Art Auctions at Leon Gallery | Philippine Art & Masterpieces',
      discription: 'Explore upcoming and past art auctions at Leon Gallery. Discover Philippine masterpieces, rare collections, and renowned artists. Join our auctions for exclusive art opportunities.',
      lotNo: '',
      canonical: `${GetURL}/faq`,
      url:  `${GetURL}/faq`,
      imagUrl:  `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
    };

    await fetch(`${GetURL}/meta`, {
      method: "POST",
      body: JSON.stringify(dataSend),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())

      .then((data) => {
        console.log("data send here ", data);
      })
      .catch((error) => {
        // alert.error(error)
        console.log("error ", error);
      });
      window.location.href = url;

    }else if(value === "HOME"){
        const dataSend = {
        title: 'Leon Gallery | Premier Philippine Art Gallery',
        discription: 'Leon Gallery is Manila’s leading art gallery and auction house specializing in Filipino masterpieces, historical works, and contemporary art. Discover exhibitions and auctions.',
        lotNo: '',
        canonical: `${GetURL}/home`,
        url: `${GetURL}/home`,
      imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
        };
    
        await fetch(`${GetURL}/meta`, {
          method: "POST",
          body: JSON.stringify(dataSend),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
    
          .then((data) => {
            console.log("data send here ", data);
          })
          .catch((error) => {
            // alert.error(error)
            console.log("error ", error);
          });
          window.location.href = url;

        }else if(value === "STORIES"){
          const dataSend = {
          title: 'Art Stories, Auction Highlights, and Artist Features | León Gallery',
          discription: 'Discover inspiring stories, auction highlights, and artist features from the Philippines premier auction house, León Gallery. Explore art insights and cultural treasures.',
          lotNo: '',
          canonical: `${GetURL}/stories`,
          url:`${GetURL}/stories`,
        imagUrl:  `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
          };
      
          await fetch(`${GetURL}/meta`, {
            method: "POST",
            body: JSON.stringify(dataSend),
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
      
            .then((data) => {
              console.log("data send here ", data);
            })
            .catch((error) => {
              // alert.error(error)
              console.log("error ", error);
            });
            window.location.href = url;

          }else if(value === "GALLERIES"){
            const dataSend = {
            title: 'Visit León Gallery - Location and Directions | Leading Art Auction House in the Philippines',
          discription: 'Find the location of León Gallery, the Philippines premier art auction house. Get directions, view the map, and plan your visit today.',
          lotNo: '',
          canonical: `${GetURL}/stories`,
          url: `${GetURL}/stories`,
          imagUrl:  `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
            };
        
            await fetch(`${GetURL}/meta`, {
              method: "POST",
              body: JSON.stringify(dataSend),
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            })
              .then((response) => response.json())
        
              .then((data) => {
                console.log("data send here ", data);
              })
              .catch((error) => {
                // alert.error(error)
                console.log("error ", error);
              });
              window.location.href = url;

             
            }else if(value === "PAINTING" || value === "SCULPTURE" || value === "BOOKS" || value === "FURNITURE" || value === "JEWELRY" || value === "OBJET D' ARTS" || value === "MAPS" || value === "WATCHES" || value === "MID-CENTURY"){
              const dataSend = {
                title: `Private ${value} Sales - Buy Fine Art | León Gallery Philippines `,
                discription: `Explore private ${value} sales at León Gallery. Discover and acquire exceptional fine art through our exclusive private sale offerings. Enquire today.`,
                lotNo: '',
                canonical: `${GetURL}/sale?data=PAINTING`,
                url: `${GetURL}/sale?data=PAINTING`,
                imagUrl:  `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
              };
          
              await fetch(`${GetURL}/meta`, {
                method: "POST",
                body: JSON.stringify(dataSend),
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              })
                .then((response) => response.json())
          
                .then((data) => {
                  console.log("data send here ", data);
                })
                .catch((error) => {
                  // alert.error(error)
                  console.log("error ", error);
                });
                window.location.href = url;

              }else if(value === "EXHIBITION"){
                const dataSend = {
                  title: 'Current & Past Art Exhibitions | Leon Gallery Manila',
                  discription: 'Explore Leon Gallery’s curated art exhibitions in Manila, featuring renowned Filipino artists and historic collections. View current, upcoming, and past shows.',
                  lotNo: '',
                  canonical: `${GetURL}/exhibition`,
                  url: `${GetURL}/exhibition`,
                  imagUrl:  `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
                };
            
                await fetch(`${GetURL}/meta`, {
                  method: "POST",
                  body: JSON.stringify(dataSend),
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                  },
                })
                  .then((response) => response.json())
            
                  .then((data) => {
                    console.log("data send here ", data);
                  })
                  .catch((error) => {
                    // alert.error(error)
                    console.log("error ", error);
                  });
                  window.location.href = url;

                }else if (value === "LIVE AUCTION"){
                 
                
                  const dataSend = {
                    title: `Live Auction | León Gallery – Premier Philippine Art Auction House`,
                    discription: `Join the live auction at León Gallery and bid on exceptional Filipino art and collectibles in real-time. Discover masterpieces, rare finds, and cultural treasures from the Philippines' premier auction house.`,
                    lotNo: '',
                    canonical: ``,
                    url: ``,
                    imagUrl:  `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
                  };
              
                  await fetch(`${GetURL}/meta`, {
                    method: "POST",
                    body: JSON.stringify(dataSend),
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                  })
                    .then((response) => response.json())
              
                    .then((data) => {
                      console.log("data send here ", data);
                    })
                    .catch((error) => {
                      // alert.error(error)
                      console.log("error ", error);
                    });
                    window.location.href = url;



                }else if(value === "MAIN" || value === "INTERNATIONAL" || value === "LA FUERZA" ){
                  const dataSend = {
                    title: `Leon Gallery ${value} Location | Philippine Art Gallery in Manila`,
                    discription: `Visit the ${value} location of Leon Gallery in Manila, home to the finest collection of Philippine art. Explore our exhibitions, auctions, and exclusive collections of Filipino masterpieces.`,
                    lotNo: '',
                    canonical: `${GetURL}/sale?data=PAINTING`,
                    url: `${GetURL}/sale?data=PAINTING`,
                    imagUrl:  `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
                  };
              
                  await fetch(`${GetURL}/meta`, {
                    method: "POST",
                    body: JSON.stringify(dataSend),
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                  })
                    .then((response) => response.json())
              
                    .then((data) => {
                      console.log("data send here ", data);
                    })
                    .catch((error) => {
                      // alert.error(error)
                      console.log("error ", error);
                    });
                    window.location.href = url;
    
                  }else if(value === "EXHIBITION"){
                    const dataSend = {
                      title: 'Current & Past Art Exhibitions | Leon Gallery Manila',
                      discription: 'Explore Leon Gallery’s curated art exhibitions in Manila, featuring renowned Filipino artists and historic collections. View current, upcoming, and past shows.',
                      lotNo: '',
                      canonical: `${GetURL}/exhibition`,
                      url: `${GetURL}/exhibition`,
                      imagUrl:  `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
                    };
                
                    await fetch(`${GetURL}/meta`, {
                      method: "POST",
                      body: JSON.stringify(dataSend),
                      headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                      },
                    })
                      .then((response) => response.json())
                
                      .then((data) => {
                        console.log("data send here ", data);
                      })
                      .catch((error) => {
                        // alert.error(error)
                        console.log("error ", error);
                      });
                      window.location.href = url;
             
          }else{
          }

  }


  const handlePage = async(value) => {
    // alert(GetURL)
      if(value === "howtosell"){
      const dataSend = {
        title: 'How To Sell Leon Gallery| How to Consign with Leon Gallery',
        discription: 'Interested in selling your artwork? Learn how to consign with Leon Gallery. Our expert team offers appraisals, personalized guidance, and global exposure.',
        lotNo: '',
        canonical: `${GetURL}/howtosell`,
        url: `${GetURL}/howtosell`,
        imagUrl:  `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
      };
  
      await fetch(`${GetURL}/meta`, {
        method: "POST",
        body: JSON.stringify(dataSend),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
  
        .then((data) => {
          console.log("data send here ", data);
        })
        .catch((error) => {
          // alert.error(error)
          console.log("error ", error);
        });
        window.location.href = "/howtosell";
  
      }else if (value === "howtobuy"){
  
        const dataSend = {
          title: "How to Buy | Join Leon Gallery’s Art Auctions & Sales",
          discription: 'Learn how to register, bid, and purchase art through Leon Gallery’s auctions. Explore steps for local and international collectors to acquire fine art.',
          lotNo: '',
          url: `${GetURL}/howtobuy`,
          canonical: `${GetURL}/howtobuy`,
          imagUrl:  `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
        };
    
        await fetch(`${GetURL}/meta`, {
          method: "POST",
          body: JSON.stringify(dataSend),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
    
          .then((data) => {
            console.log("data send here ", data);
          })
          .catch((error) => {
            // alert.error(error)
            console.log("error ", error);
          });
          window.location.href = "/howtobuy";
  
        }else if (value === "FAQ"){
  
          const dataSend = {
            title: 'Leon Gallery FAQ | Answers About Art Sales & Exhibitions',
            discription: 'Find answers to frequently asked questions about Leon Gallery’s exhibitions, art purchases, payment options, shipping, and more. Get the info you need here.',
            lotNo: '',
            canonical: `${GetURL}/faq`,
            url: `${GetURL}/faq`,
            imagUrl: `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
          };
      
          await fetch(`${GetURL}/meta`, {
            method: "POST",
            body: JSON.stringify(dataSend),
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
      
            .then((data) => {
              console.log("data send here ", data);
            })
            .catch((error) => {
              // alert.error(error)
              console.log("error ", error);
            });
            window.location.href = "/faq";
  
            

       

          

        }else if (value === "contatcUS"){
  
          const dataSend = {
            title: 'Contact Leon Gallery | Reach Out to the Philippines Premier Art Auction House',
              discription: 'Have questions about art auctions, consignments, or exhibitions? Contact Leon Gallery in Makati via email, phone, or visit us in person.',
              lotNo: '',
              canonical: `${GetURL}/contact`,
              url: `https://leon-gallery.com/contact`,
              imagUrl:  `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
          };
      
          await fetch(`${GetURL}/meta`, {
            method: "POST",
            body: JSON.stringify(dataSend),
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
      
            .then((data) => {
              console.log("data send here ", data);
            })
            .catch((error) => {
              // alert.error(error)
              console.log("error ", error);
            });
            window.location.href = "/contact";
  
        }else if (value === "aboutUS"){
  
          const dataSend = {
            title: 'About Us Leon Gallery | Philippine Art, History & Vision',
            discription: 'Discover the story behind Leon Gallery — a premier auction house and gallery in Manila. Learn about our mission, team, and dedication to Philippine art and heritage.',
            lotNo: '',
            canonical: `${GetURL}/about`,
            url: `${GetURL}/about`,
            imagUrl:  `${GetURL}/static/media/dddd.f96bbcbee8c8c2f5e3ee.png`,
          };
      
          await fetch(`${GetURL}/meta`, {
            method: "POST",
            body: JSON.stringify(dataSend),
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
      
            .then((data) => {
              console.log("data send here ", data);
            })
            .catch((error) => {
              // alert.error(error)
              console.log("error ", error);
            });
            window.location.href = "/about";
  
    }else{
  
    }

  }

  
  return (
    <nav className="main-menu style4 navbar-expand-lg">
      <div className="navbar-header">
        {/*Toggle Link*/}
        <Link
          type="Link"
          className="navbar-toggle"
          // data-toggle="collapse"
          // data-target="#navbarSupportedContent"
          // aria-controls="navbarSupportedContent"
          // aria-expanded="false"
          onClick={ShowLefSide}
          aria-label="Toggle navigation"
        >
          <MenuIcon style={{ color: "#030202", background: "#ffff" }} />
        </Link>
      </div>

      <div
        className="navbar-collapse collapse clearfix"
        // id="navbarSupportedContent"
      >
        {/* onClick={event => CallFunction(event, row.handle,row.name)} */}
        <ul className="navigation clearfix" id="navOne">
          {linksData.map((val, i) => (
            <li key={i} className={val.class}>
              <a onClick={(e) =>handleGotPage(val.name,val.to)}>
                <Typography
                  style={{
                     fontFamily: "Bell MT Semi Bold",
                    fontSize: 17,
                    textDecoration: title === val.title ? "underline" : "",
                    textUnderlineOffset: 10,
                    cursor: 'pointer',
                  }}
               
                >
                
                  {val.name}
                </Typography>
              </a>
              <ul class="dropdown-content">
                {val?.dropdown?.map((row, index) => (
                  <li key={index} className={row.class}>
                     <a onClick={(e) =>handleGotPage(row.name,`${row.to}?data=${row.name}`)}>
                      <Typography
                        style={{
                          fontFamily: "Bell MT Semi Bold",
                          fontSize: 17,
                          cursor: 'pointer',
                        }}
                      >
                        {row.name}
                      </Typography>
                    </a>
                    <ul>
                      {row?.dropdown2?.map((res, index) => (
                        <li key={index}>
                          <a href={`${res.to}?data=${res.name}`}>
                            <Typography
                              style={{
                                fontFamily: "Bell MT Semi Bold",
                                fontSize: 17,
                              }}
                            >
                              {res.name}
                            </Typography>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>

      <div style={{ maxHeight: 800 }}>
        <div
          className="right-align"
          style={{
            display: leftside === true ? "block" : "none",
            position: "fixed",
            top: 0,
            width: "100%",
            height: "100%",
            background: "#ffffff",
            zIndex: 9999999999,
            transition: "all 700ms ease",
            left: leftside === true ? 0 : -400,
            boxShadow: "0px 5px 10px 5px rgba(0, 0, 0, 0.5)",
          }}
          id="inputSearch"
        >
          <div
            className="hidden-bar-closer"
            style={{ marginLeft: 10, display: "flex" }}
          >
            <div
              style={{
                height: "auto",
                marginTop: 30,
                marginBottom: "1rem",
                width: "95%",
              }}
            >
              <form onSubmit={handleSearch}>
                <Paper
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  {/* <IconButton sx={{ p: '10px' }} aria-label="menu">
                    <MenuIcon />
                  </IconButton> */}

                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder="Search "
                    onChange={(e) => setSearch(e.target.value)}
                    required={true}
                    // type="search"
                    name="search"
                  />
                  <IconButton
                    type="submit"
                    sx={{ p: "10px" }}
                    aria-label="search"
                  >
                    <SearchIcon />
                  </IconButton>

                  <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                  <IconButton
                    onClick={ShowLefSide}
                    color="primary"
                    sx={{ p: "10px" }}
                    aria-label="directions"
                  >
                    <ClearIcon />
                  </IconButton>
                </Paper>
              </form>
            </div>
          </div>
          <hr className="singleline" />
          <div>
            <div className="hidden-bar-wrapper">
              <div
                className={"navbar-collapse collapse clearfix show"}
                id="navbarSupportedContent"
              > 
                <ul className="navigation clearfix">
                  {linksData.map((val, i) => (
                    <li key={i} className={val.class}>
                  
           

                          <a  onClick={(e) =>handleGotPage(val.name,val.to)}>

                          <i  style={{fontSize:20,paddingRight: val.name === "PRIVATE SALE" ? 20:15 ,color: '#212529'}} className={val.icon} />  


                    
                        {val.name}
                      </a>

                      <ul
                        style={{
                          backgroundColor: "#f1f1f1",
                          paddingLeft: 50,
                          display:
                            val.name === menuName
                              ? status === true
                                ? "block"
                                : "none"
                              : "none",
                        }}
                      >
                        {val?.dropdown?.map((row, index) => (
                          <li key={index}>
                               <a onClick={(e) =>handleGotPage(row.name,`${row.to}?data=${row.name}`)}>
                           
                              <Typography
                                style={{
                                  fontFamily: "Bell MT Semi Bold",
                                  fontSize: 15,
                                }}
                              >
                                {row.name}
                              </Typography>
                            </a>
                            <ul>
                              {row?.dropdown2?.map((res, index) => (
                                <li key={index}>
                                  <a href={`${res.to}?data=${res.name}`}>
                                    <Typography
                                      style={{
                                        fontFamily: "Bell MT Semi Bold",
                                        fontSize: 15,
                                      }}
                                    >
                                      {res.name}
                                    </Typography>
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
                <hr className="singleline" />


                <ul class="navigation clearfix" >
                  <li>
                    <a onClick={(e)=> handlePage('aboutUS')} style={{height: 40}}>
                      <Typography
                        style={{
                          fontFamily: "Bell MT Semi Bold",
                          fontSize: 15,
                        }}
                      >
                        ABOUT US
                      </Typography>
                    </a>
                  </li>
                  <li>
                    <a onClick={(e)=> handlePage('contatcUS')}  style={{height: 40}}>
                      <Typography
                        style={{
                          fontFamily: "Bell MT Semi Bold",
                          fontSize: 15,
                        }}
                      >
                        CONTACT US
                      </Typography>
                    </a>
                  </li>

                  <li>
                    <a onClick={(e)=> handlePage('howtobuy')}  style={{height: 40}}>
                      <Typography
                        style={{
                          fontFamily: "Bell MT Semi Bold",
                          fontSize: 15,
                        }}
                      >
                        {" "}
                        HOW TO BUY
                      </Typography>
                    </a>
                  </li>

                  <li>
                    <a onClick={(e)=> handlePage('howtosell')}  style={{height: 40}}>
                      <Typography
                        style={{
                          fontFamily: "Bell MT Semi Bold",
                          fontSize: 15,
                        }}
                      >
                        HOW TO SELL
                      </Typography>
                    </a>
                  </li>

                  <li>
                    <a    onClick={(e)=> handlePage('FAQ')}  style={{height: 40}}>
                      <Typography
                        style={{
                          fontFamily: "Bell MT Semi Bold",
                          fontSize: 15,
                        }}
                      >
                        FAQ
                      </Typography>
                    </a>
                  </li>
                {token !== "" ? (
                      <li>
                      
                      <a style={{fontFamily:  "Bell MT Semi Bold",}}  href="/room" style={{height: 40}}> 
                      <Typography
                        style={{
                          fontFamily: "Bell MT Semi Bold",
                          fontSize: 15,
                        }}
                      >
                         MY ACCOUNT
                      </Typography>
        </a>
                      </li>
                    ) : (
                      <li>
                        <a style={{fontFamily:  "Bell MT Semi Bold",}}  href="/login" style={{height: 40}}> 
                      <Typography
                        style={{
                          fontFamily: "Bell MT Semi Bold",
                          fontSize: 15,
                        }}
                      >
                         LOGIN
                      </Typography>
        </a>

                       
                      </li>
                    )} 
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
